import axios from "axios";
import {
  USER_PRODUCTIVITY_REQUEST,
  USER_PRODUCTIVITY_SUCCESS,
  USER_PRODUCTIVITY_FAIL,
  USER_MONTH_PRODUCTIVITY_REQUEST,
  USER_MONTH_PRODUCTIVITY_SUCCESS,
  USER_MONTH_PRODUCTIVITY_FAIL,
  USER_PREV_PRODUCTIVITY_FAIL,
  USER_PREV_PRODUCTIVITY_REQUEST,
  USER_PREV_PRODUCTIVITY_SUCCESS,
} from "../../types/user/productiveTypes";
//import moment from "moment";
import dayjs from "dayjs";

//Productivity Today List
export const userProductAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PRODUCTIVITY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: dayjs(date).format("YYYY-MM-DD"),
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/productivity/${companyId}/date`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: USER_PRODUCTIVITY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PRODUCTIVITY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Productivity Prev List
export const userPrevProductAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_PREV_PRODUCTIVITY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: dayjs(date).subtract(1, "day").format("YYYY-MM-DD"),
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/productivity/${companyId}/date`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: USER_PREV_PRODUCTIVITY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_PREV_PRODUCTIVITY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Screen Shot Monthly List
export const userMonthProductAction =
  (companyId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: USER_MONTH_PRODUCTIVITY_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        month: `${dayjs(new Date()).format("M")}`,
        year: `${dayjs(new Date()).format("YYYY")}`,
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/productivity/${companyId}/month`,
        body,
        config
      );
      // console.log({ data });
      dispatch({
        type: USER_MONTH_PRODUCTIVITY_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: USER_MONTH_PRODUCTIVITY_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
